import mountReactApp from 'src/utils/mountReactApp'
import Impact         from 'src/components/impact/Impact'
import ImpactContent  from 'src/components/impact/ImpactContent'

mountReactApp(Impact, props => ({ ...props, ImpactContent }))
